// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
  Typography,
  Divider,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
} from "@mui/material";

// import {
//   addEmployee,
//   getNewSubscriptionReachageDetails,
//   updateEmployee,
// } from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
// import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
// import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import { ModalHeader } from "../../common/modalHeader";
// import { getAlldetailSerice } from "../services/servicesListApi";
import calendar from "../../assets/icon/calendarblack.png";
import { jobPostAdd, jobPostUpdate } from "./jobsApi";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function AddPost({
  open,
  setOpen,
  modalData,
  setModalData,
  getAllJobPosts,
}) {
  const struct = {
    status: 1,
    fromDate: null,
    toDate: null,
    mobileNumber: "",
    designation: "",
    eligibility: "",
    jobDescriptions: "",
    expertise: "",
    gender: "",
    jobTiming: "",
    preferredLocation: "",
    noOfVacancies: 0,
    diplomaRequired: true,
    education: "",
    experienceYears: 0,
    experienceMonths: 0,
    minSalary: 0,
    maxSalary: 0,
    incentive: true,
    joinedWithinDays: "",
  };

  const onClose = () => {
    setOpen(false);
  };

  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState({ ...struct });
  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  const numberFields = [
    "noOfVacancies",
    "experienceYears",
    "experienceMonths",
    "minSalary",
    "maxSalary",
  ];
  const handleChange = (e) => {
    const { name, value } = e.target;

    // if (numberFields.includes(name)) {
    //   setFormData((prev) => ({
    //     ...prev,
    //     [name]: value === "" ? 0 : Number(value),
    //   }));
    //   return;
    // }
    if (numberFields.includes(name)) {
      const numValue = Number(value);

      setFormData((prev) => ({
        ...prev,
        [name]: isNaN(numValue) ? 0 : numValue,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    setFormData((prev) => ({
      ...prev,
      fromDate: newValue
        ? dayjs(newValue).utc().format("YYYY-MM-DDTHH:mm:ss")
        : null,
    }));

    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    setFormData((prev) => ({
      ...prev,
      toDate: newValue
        ? dayjs(newValue).utc().format("YYYY-MM-DDTHH:mm:ss")
        : null,
    }));

    setEndDateOpen(false);
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };

  useEffect(() => {
    if (open === true && modalData) {
      console.log("modalData", modalData);
      setFormData({
        ...modalData,

        // id: modalData?.id,
      });
      setSelectedStartDate(
        modalData.fromDate ? dayjs(modalData.fromDate) : null,
      );
      setSelectedEndDate(modalData.toDate ? dayjs(modalData.toDate) : null);
      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      setFormData({ ...struct });
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
    // setstartDateFormat(dayjs("2024-12-12T00:00:00"));
  }, [open, modalData]);

  const validateJobPost = (data) => {
    if (!data.fromDate) {
      return { status: false, message: "Start date is required" };
    }

    if (!data.toDate) {
      return { status: false, message: "End date is required" };
    }

    if (dayjs(data.fromDate).isAfter(dayjs(data.toDate))) {
      return { status: false, message: "Start date must be before end date" };
    }
    if (!data.mobileNumber || !/^\d{10}$/.test(data.mobileNumber)) {
      return {
        status: false,
        message: "Enter a valid 10-digit mobile number",
      };
    }
    if (!data.designation?.trim()) {
      return { status: false, message: "Designation is required" };
    }
    if (!data.jobDescriptions?.trim()) {
      return { status: false, message: "Job Descriptions is required" };
    }
    if (data.noOfVacancies <= 0) {
      return { status: false, message: "Vacancies must be greater than 0" };
    }

    if (data.experienceYears < 0) {
      return { status: false, message: "Experience years cannot be negative" };
    }

    if (data.experienceMonths < 0 || data.experienceMonths > 11) {
      return {
        status: false,
        message: "Experience months must be between 0 and 11",
      };
    }
    if (data.minSalary <= 0 || data.maxSalary <= 0) {
      return { status: false, message: "Salary must be greater than 0" };
    }

    if (data.minSalary > data.maxSalary) {
      return {
        status: false,
        message: "Minimum salary cannot exceed maximum salary",
      };
    }
    if (!data.joinedWithinDays || isNaN(data.joinedWithinDays)) {
      return { status: false, message: "Joined within days must be a number" };
    }

    return { status: true };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(appnType, "appnType");
    const payload = {
      ...formData,
      joinedWithinDays: formData.joinedWithinDays?.toString() ?? "",
    };

    const validation = validateJobPost(payload);

    if (!validation.status) {
      Swal.fire({
        text: validation.message,
        icon: "warning",
        ...swalAlertPopProps,
      });
      return;
    }

    if (modalData?.id) {
      // UPDATE
      payload.id = modalData.id;
      jobPostUpdate(payload, () => {
        getAllJobPosts();

        setOpen(false);
      });
    } else {
      // ADD
      jobPostAdd(payload, () => {
        getAllJobPosts();

        setOpen(false);
      });
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "70%", lg: "60%" },
          overflowY: "auto",
          height: { xs: "80vh", sm: "70vh", md: "72vh", lg: "75vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "15%", md: "20%", lg: "20%" },
          top: "10%",
        }}
      >
        <ModalHeader
          title={`${modalData ? "Update" : "Add"} Job Hiring Post`}
          onClose={onClose}
        />
        {/* <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "auto",
            p: "0px 10px !important",
          }}
        >
          Employee Information{" "}
          <CloseIcon
            sx={{ float: "right", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle> */}

        <DialogContent sx={{ p: 2, mt: 0 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ pt: 1 }} alignItems="center">
              {modalData?.id && (
                <Grid item xs={12} sm={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={10}
                    // justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Post Status
                    </Typography>
                    <Switch
                      checked={formData.status === 1}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          status: e.target.checked ? 1 : 0,
                        }));
                      }}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Date :"
                  size="small"
                  value={
                    SelectedStartDate && SelectedEndDate
                      ? `${SelectedStartDate.format(
                          "DD-MM-YYYY",
                        )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                      : SelectedStartDate
                        ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                        : ""
                  }
                  id="datepickerfield"
                  placeholder="Select date range"
                  InputProps={{
                    // sx: {
                    //   color: "#545454",
                    //   fontWeight: 400,
                    //   paddingX: "7px",
                    // },
                    readOnly: true,
                    endAdornment: (
                      <CalendarMonthIcon
                        sx={{
                          cursor: "pointer",
                          mr: 1,
                        }}
                        onClick={() => setStartDateOpen(true)} // trigger open
                      />
                    ),
                    sx: {
                      background: "#fff",
                      borderRadius: 1,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      cursor: "pointer",
                      fontFamily: "'Montserrat', sans-serif",
                      fontWeight: 500,
                    },
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  onClick={() => setStartDateOpen(true)} // trigger open
                  sx={{ width: "100%" }}
                />

                <Box sx={{ position: "relative" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={startDateOpen}
                      onOpen={() => setStartDateOpen(true)}
                      onClose={() => setStartDateOpen(false)}
                      value={SelectedStartDate}
                      onChange={(val) => {
                        datePickerOnChange(val);
                      }}
                      maxDate={SelectedEndDate || undefined}
                      slotProps={{
                        popper: {
                          placement: "bottom-end",
                          anchorEl: document.querySelector("#datepickerfield"),
                          sx: { zIndex: 1500 },
                        },
                        textField: { style: { display: "none" } },
                      }}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={endDateOpen}
                      onOpen={() => setEndDateOpen(true)}
                      onClose={() => setEndDateOpen(false)}
                      value={SelectedEndDate}
                      onChange={(val) => {
                        datePickerOnChangeEnd(val);
                      }}
                      minDate={SelectedStartDate || undefined}
                      slotProps={{
                        popper: {
                          placement: "bottom-start",
                          anchorEl: document.querySelector("#datepickerfield"),
                          sx: { zIndex: 1500 },
                        },
                        textField: { style: { display: "none" } },
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Contact Person Mobile Number :"
                    name="mobileNumber"
                    size="small"
                    value={formData.mobileNumber}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Designation <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="designation"
                    size="small"
                    value={formData.designation}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Eligibility :<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="eligibility"
                    size="small"
                    value={formData.eligibility}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Job Description :<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="jobDescriptions"
                    size="small"
                    value={formData.jobDescriptions}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Expertise :<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="expertise"
                    size="small"
                    value={formData.expertise}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    className="mulish"
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Gender <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Female
                        </Typography>
                      }
                      checked={
                        formData.gender == "female" ||
                        formData.gender == "Female"
                      }
                      className="mulish"
                      onClick={gender}
                    />
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      checked={
                        formData.gender == "male" || formData.gender == "Male"
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Male
                        </Typography>
                      }
                      className="mulish"
                      onClick={gender}
                    />
                    <FormControlLabel
                      value="other"
                      control={<Radio />}
                      checked={
                        formData.gender == "other" || formData.gender == "Other"
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Other
                        </Typography>
                      }
                      className="mulish"
                      onClick={gender}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Job Timing : <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="jobTiming"
                    size="small"
                    value={formData.jobTiming}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Preferred Location :{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="preferredLocation"
                    size="small"
                    value={formData.preferredLocation}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Perks and Benefits :{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="perksAndBenefits"
                    size="small"
                    value={formData.perksAndBenefits}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        No. of Vacancies :{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="noOfVacancies"
                    size="small"
                    value={formData.noOfVacancies}
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    className="mulish"
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Salon Diploma Required:{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={formData.diplomaRequired}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        diplomaRequired: e.target.value === "true",
                      }))
                    }
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Yes
                        </Typography>
                      }
                      checked={
                        formData.diplomaRequired == "yes" ||
                        formData.diplomaRequired == true
                      }
                      className="mulish"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      checked={
                        formData.diplomaRequired == "false" ||
                        formData.diplomaRequired == false
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          No
                        </Typography>
                      }
                      className="mulish"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Education : <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="education"
                    size="small"
                    value={formData.education}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, color: "#01008B" }}
                  >
                    Experience:
                  </Typography>

                  <TextField
                    label="Years"
                    name="experienceYears"
                    size="small"
                    value={formData.experienceYears}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                  <TextField
                    label="Months"
                    name="experienceMonths"
                    size="small"
                    value={formData.experienceMonths}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  //   gap={2}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, color: "#01008B" }}
                  >
                    Ready to Join within:
                  </Typography>

                  <Box display="flex" alignItems="center" gap={2}>
                    <TextField
                      select
                      label="Days"
                      name="joinedWithinDays"
                      size="small"
                      value={formData.joinedWithinDays || ""}
                      onChange={handleChange}
                      InputProps={{
                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      sx={{ minWidth: 120 }}
                    >
                      {Array.from({ length: 30 }, (_, i) => (
                        <MenuItem key={i + 1} value={i + 1}>
                          {i + 1}
                        </MenuItem>
                      ))}
                    </TextField>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Days
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, color: "#01008B" }}
                  >
                    Salary:
                  </Typography>

                  <TextField
                    label="Minimum"
                    name="minSalary"
                    size="small"
                    value={formData.minSalary}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                  <TextField
                    label="Maximum"
                    name="maxSalary"
                    size="small"
                    value={formData.maxSalary}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    className="mulish"
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Incentive <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        incentive: e.target.value === "true",
                      }))
                    }
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Yes
                        </Typography>
                      }
                      checked={formData.incentive == true}
                      className="mulish"
                      // onClick={incentive}
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      checked={formData.incentive == false}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          No
                        </Typography>
                      }
                      className="mulish"
                      // onClick={incentive}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {/* .. */}
            </Grid>

            <Divider
              sx={{
                borderColor: "#4E4E4E",
                borderBottomWidth: 1,
                marginTop: 2,
                marginBottom: 1,
              }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                sx={{ width: { sm: "70%", xs: "100%" } }}
                variant="contained"
                // sx={{
                //   backgroundColor: "#3695B6",
                //   padding: "14px",
                //   fontSize: "16px",
                // }}
              >
                {modalData ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Box>
    </Modal>
  );
}
